import * as I18n from 'i18n-js';
import * as React from 'react';
import CoreLink from '@reverbdotcom/commons/dist/components/core_link';

const ACTIVE_CLASS = 'feed-container__tab--active';

export default function FeedTabs() {
  return (
    <nav className="feed-container__tabs">
      <ul>
        <li className="feed-container__tab">
          <CoreLink to="/my/feed" activeClassName={ACTIVE_CLASS}>
            {I18n.t('discovery.feed.tabs.feed')}
          </CoreLink>
        </li>
        <li className="feed-container__tab">
          <CoreLink to="/my/feed/customize" activeClassName={ACTIVE_CLASS}>
            {I18n.t('discovery.feed.tabs.customize')}
          </CoreLink>
        </li>
        <li className="feed-container__tab">
          <CoreLink to="/watched_products" activeClassName={ACTIVE_CLASS}>
            {I18n.t('discovery.feed.tabs.watchList')}
          </CoreLink>
        </li>
        <li className="feed-container__tab">
          <CoreLink to="/browsing_history" activeClassName={ACTIVE_CLASS}>
            {I18n.t('discovery.feed.tabs.recentlyViewed')}
          </CoreLink>
        </li>
      </ul>
    </nav>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/feed/tabs.tsx